function TidalException(message: string, e_type: string) {
    this.message = message
    this.type = e_type
}

export default TidalException;